export default __webpack_public_path__ + "static/media/family.cf96a8a4.svg";